import { render, staticRenderFns } from "./ViewClientIndividual.vue?vue&type=template&id=1dd802fc"
import script from "./ViewClientIndividual.vue?vue&type=script&lang=js"
export * from "./ViewClientIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports